var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.01 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#c39;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M39.73,14.99c.39,0,.72,.24,.87,.57l6.3,9.75c.08,.15,.11,.32,.1,.48l-.42,23.27c0,.52-.42,.94-.94,.94H1.44c-.52,0-.94-.42-.94-.94L0,25.74H0v-.02H0v-.02H0v-.02H0v-.03H0v-.02H0v-.02H0v-.02h0v-.02h0v-.02h0v-.02H.02v-.02h0v-.02h0v-.02h.01v-.02h0v-.02h0v-.02h0v-.02h0v-.02h0v-.02h.01v-.02h.02v-.02h0v-.02h0v-.02h.01v-.02h.01v-.02h0v-.02L6.54,15.48c.17-.32,.5-.5,.83-.5h12.63L27.33,0l11.99,5.37-4.63,9.62h5.05Zm-20.66,1.89H7.93l-5.42,7.93H44.53l-5.36-7.93h-5.38l-1.42,2.95h1.04c.52,0,.94,.42,.94,.94s-.42,.94-.94,.94H14.99c-.52,0-.94-.42-.94-.94s.42-.94,.94-.94h2.64l1.45-2.96h0Zm11.05,2.95l5.57-11.63c-.94-.46-1.32-1.59-.87-2.53l-5.05-1.97c-.46,.94-1.59,1.32-2.53,.87l-7.19,14.69h0c.28,.14,.51,.34,.69,.57,3.04,0,6.4,0,9.36,0h0Zm-5-7.07c.73-1.49,2.52-2.1,4.01-1.38s2.1,2.52,1.38,4.01-2.52,2.1-4.01,1.38c-1.49-.72-2.1-2.52-1.38-4.01h0ZM1.88,26.69l.5,21.42H44.71l.42-21.42H1.88Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonation);
export default __webpack_public_path__ + "static/media/Donation.855c4fc29981acf9a4e2c9d922afbe7a.svg";
export { ForwardRef as ReactComponent };